var classes = {"arrowControl":"Q42Wr"};

export { classes as default };
